async function detectBrowser() {
  const { userAgent } = navigator

  // Check for Brave
  if ((navigator.brave && (await navigator.brave.isBrave())) || userAgent.indexOf('Brave') !== -1) {
    return 'brave'
  }

  if (getComputedStyle(document.documentElement).getPropertyValue('--arc-palette-title')) {
    return 'arc'
  }

  // Check for Firefox
  if (userAgent.indexOf('Firefox') !== -1) {
    return 'firefox'
  }

  // Check for Safari (but exclude Chrome and Edge which also contain 'Safari')
  if (
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1 &&
    userAgent.indexOf('Edg') === -1
  ) {
    return 'safari'
  }

  // Check for Chrome (but exclude Edge, which also contains 'Chrome')
  if (
    userAgent.indexOf('Chrome') !== -1 &&
    userAgent.indexOf('Edg') === -1 &&
    userAgent.indexOf('OPR') === -1
  ) {
    return 'chrome'
  }

  // Check for Edge
  if (userAgent.indexOf('Edg') !== -1) {
    return 'edge'
  }

  // Check for Opera
  if (userAgent.indexOf('OPR') !== -1) {
    return 'opera'
  }

  // Default fallback
  return 'unknown'
}

export default detectBrowser
